module.exports = __webpack_public_path__ + "img/vg.4da08a95.svg";